const translations = {
  common: {
    search: '検索',
    searching: '検索中',
    signIn: 'サインイン',
    register: '登録',
    myAccount: 'マイアカウント',
    support: 'サポート',
    followUs: 'X/Twitterでフォロー',
    proMembership: 'プロメンバーシップ',
    new: '新規',
    proMember: 'プロメンバー',
    upgrade: 'アップグレード',
    subscribe: '購読',
    manage: '管理',
    cancel: 'キャンセル',
    close: '閉じる',
    or: 'または',
    email: 'メールアドレス',
    continue: '続ける',
    submit: '送信',
    billing: '請求',
    sort: '並び替え',
    language: '言語',
    selectLanguage: '言語を選択',
    searchPlaceholder: '検索...',
    cards: 'カード',
    previous: '前へ',
    next: '次へ',
    pagination: 'ページネーション',
    back: '戻る',
    backToSets: 'セットに戻る',
    error: 'エラーが発生しました。もう一度お試しください。',
    home: 'ホーム',
    sets: 'セット',
    login: 'ログイン',
    loginRequired: 'この機能を利用するにはログインしてください',
    adding: '追加中...',
  },
  languages: {
    default: 'デフォルト',
    any: 'すべて',
    english: '英語',
    spanish: 'スペイン語',
    french: 'フランス語',
    german: 'ドイツ語',
    italian: 'イタリア語',
    portuguese: 'ポルトガル語',
    japanese: '日本語',
    korean: '韓国語',
    russian: 'ロシア語',
    simplified_chinese: '簡体字中国語',
    traditional_chinese: '繁体字中国語',
    hebrew: 'ヘブライ語',
    latin: 'ラテン語',
    ancient_greek: '古代ギリシャ語',
    arabic: 'アラビア語',
    sanskrit: 'サンスクリット語',
    phyrexian: 'ファイレクシア語',
    quenya: 'クウェンヤ語',
  },
  filters: {
    show: '✨ Proフィルターを表示',
    hide: '✨ Proフィルターを非表示',
  },
  search: {
    showing_start: '表示中',
    showing_to: 'から',
    showing_of: '件中',
    showing_results: '件の結果',
    noResults: '結果が見つかりません。',
    useSearchTip: 'ページ上部の検索を使用してカードを検索してください。',
  },
  sort: {
    nameAsc: '名前 (A to Z)',
    nameDesc: '名前 (Z to A)',
    cmcAsc: 'マナ・コスト (低い順)',
    cmcDesc: 'マナ・コスト (高い順)',
    usdAsc: '価格 (安い順)',
    usdDesc: '価格 (高い順)',
    rarityAsc: 'レアリティ (コモン→神話レア)',
    rarityDesc: 'レアリティ (神話レア→コモン)',
    releasedDesc: '発売日 (新しい順)',
    releasedAsc: '発売日 (古い順)',
  },
  pages: {
    search: {
      heading: 'MTGカード検索',
    },
    sets: {
      heading: 'カードセット',
      latestSets: '最新セット',
      upcomingSets: '今後のセット',
      allSets: 'すべてのセット',
      noResults: '結果が見つかりません。',
    },
    set: {
      notFound: 'セットが見つかりません。',
      noCards: 'このセットにカードが見つかりません。',
      addAll: '{{count}}枚のカードをプロキシリストに追加',
      addedToList: '{{count}}枚のカードをプロキシリストに追加しました',
    },
    tokens: {
      heading: 'トークン',
    },
    emblems: {
      heading: 'エンブレム',
    },
    import: {
      heading: 'プロキシリストにカードをインポート',
      description: 'プロキシリストに追加したいすべてのカードの名前を入力してください。',
    },
    topProxies: {
      heading: '人気のプロキシ',
      description: 'TCG Stackedで最も人気のある50枚のMTGプロキシカードです。',
    },
  },
  theme: {
    light: 'ライト',
    dark: 'ダーク',
    toggle: 'テーマ切替',
  },
  cta: {
    title: '始める準備はできましたか？',
    subtitle: '今日からプロキシカードを作成しましょう。',
    searchByCard: 'カードで検索',
    searchBySet: 'セットで検索',
  },
  nav: {
    magicTheGathering: 'Magic: The Gathering',
    pokemon: 'ポケモン',
    sets: 'セット',
    tokens: 'トークン',
    emblems: 'エンブレム',
    import: 'インポート',
    topProxies: '人気のプロキシ',
    customCards: 'カスタムカード',
    deckBuilder: 'デッキビルダー',
    buildDeck: 'デッキを作成',
    publicDecks: '公開デッキ',
    favoriteDeck: 'お気に入りデッキ',
    articles: '記事',
    feedback: 'フィードバックを共有',
    collection: 'マイコレクション',
    pokemonSets: 'ポケモンセット',
    pokemonSearch: 'ポケモンカード検索',
  },
  seo: {
    collection: {
      title: 'マイカードコレクション | TCG Stacked',
      description: '個人のカードコレクションを管理。マジック：ザ・ギャザリングのカードを一つの場所で追跡、整理、評価。',
    },
    home: {
      title: 'TCG Stacked - トレーディングカードゲームのプロキシカード',
      description: 'トレーディングカードゲームのプロキシカードの広大なライブラリにアクセス。カジュアルプレイ用のカード画像を簡単に表示・印刷。今すぐ夢のデッキを作り始めましょう！',
    },
    sets: {
      title: 'カードセット - TCG Stacked',
      description: 'すべてのカードセットを閲覧し、デッキ用のプロキシを印刷。',
    },
    tokens: {
      title: 'トークン - TCG Stacked',
      description: '様々なプロキシトークンでゲームを強化。',
    },
    emblems: {
      title: 'エンブレム - TCG Stacked',
      description: 'デッキ用のエンブレムプロキシカードを印刷。',
    },
    search: {
      title: 'カード検索 - TCG Stacked',
      description: 'プロキシカードを簡単に検索・印刷。検索ツールを使用して広大なデータベースにアクセスし、デッキをプロキシで強化。',
    },
    support: {
      title: 'サポート - TCG Stacked',
      description: '質問、フィードバック、またはトークン/エンブレムの追加をご希望の場合は、メールでお問い合わせください。',
    },
    articles: {
      title: '記事 - TCG Stacked',
      description: 'トレーディングカードゲームとプロキシカードについての記事。',
    },
    import: {
      title: 'インポート - TCG Stacked',
      description: 'カードリストをインポートしてプロキシを印刷。',
    },
    topProxies: {
      title: '人気のプロキシ - TCG Stacked',
      description: 'TCG Stackedで最も人気のあるプロキシカードを表示。',
    },
    customCards: {
      title: 'カスタムカード - TCG Stacked',
      description: '独自のトレーディングカードゲームプロキシカードを作成。',
    },
    login: {
      title: 'サインイン - TCG Stacked',
      description: 'アカウントにサインインしてカスタムカード、デッキリストなどを管理。',
    },
    register: {
      title: '登録 - TCG Stacked',
      description: 'アカウントを登録してカスタムカード、デッキリストなどを管理。',
    },
    termsOfService: {
      title: '利用規約 - TCG Stacked',
      description: 'サイトの利用規約を読む。',
    },
    privacyPolicy: {
      title: 'プライバシーポリシー - TCG Stacked',
      description: 'サイトのプライバシーポリシーを読む。',
    },
    account: {
      title: 'アカウント - TCG Stacked',
      description: 'アカウントを管理。',
    },
    proMembership: {
      title: 'Proメンバーシップ - TCG Stacked',
      description: 'Proメンバーシップに登録してサイトのすべての機能にアクセス。',
    },
    deckBuilder: {
      title: 'デッキビルダー - TCG Stacked',
      description: 'トレーディングカードゲームのデッキを作成・管理。',
    },
    deckEditor: {
      title: 'デッキエディター - TCG Stacked',
      description: 'トレーディングカードゲームのデッキを作成・編集。',
    },
    publicDecks: {
      title: '公開デッキ - TCG Stacked',
      description: 'コミュニティが共有する公開デッキを閲覧・探索。',
    },
  },
  pro: {
    pricing: {
      title: 'MTGプロキシ体験をレベルアップ',
      subtitle: 'Proになって、プロキシを次のレベルに引き上げる独占機能を提供する広告なしのプレミアム体験をお楽しみください！',
      monthlyPlan: '月間パワーブースト',
      yearlyPlan: '年間お得プラン',
      monthlyPrice: '月額5.00ドル',
      yearlyPrice: '年額40.00ドル',
      subscribeMonthly: '今すぐ始める',
      subscribeYearly: '年間プランで節約',
      signInToSubscribe: 'サインインしてProを解除',
      manageSubscription: 'Pro特典を管理',
      nextBillingDate: '次回お支払い日',
      benefitsEndDate: 'Proアクセス期限',
      viewInvoice: '領収書を表示',
      changePlan: 'プランを変更する',
      reactivate: 'Pro特典を復活',
      active: 'アクティブな状態',
      cancelled: 'キャンセル済み',
      freeTrial: '無料トライアル',
      freeTrialEnds: '無料トライアル終了日',
      startFreeTrial: '7日間の無料トライアルを開始',
      signInForFreeTrial: '7日間の無料トライアルにサインイン',
      current: '現在',
      subscribe: '購読',
    },
    benefits: {
      title: 'TCG StackedでProを選ぶ理由',
      subtitle: 'これらの独占Pro機能でMTG体験を向上させた何百人ものプレイヤーに参加しましょう！',
      noAds: {
        title: '純粋な広告なし体験',
        description: '中断にさよなら！広告、バナー、ポップアップのない完璧なインターフェースをお楽しみください。純粋なMTG体験。',
      },
      darkMode: {
        title: '可視的なダークモード',
        description: '目に優しくスタイリッシュ！夜間のプレイヤーや、どんな照明環境でのプロキシマラソンセッションにも最適です。',
      },
      advancedSearch: {
        title: 'Proレベル検索マジック',
        description: '強力なフィルターで必要なカードを正確に見つけましょう！完璧なデッキを構築するための色アイデンティティ、レアリティ、カードタイプなどのフィルター。',
      },
      multipleDecks: {
        title: '無制限デッキ作成',
        description: 'デッキビルダーの天国！カジュアルな魅力から強力な競争マシンまで、好きな数のデッキを作成し保存できます。',
      },
      futureFeatures: {
        title: '新機能への優先アクセス',
        description: 'イノベーションの最前線にいましょう！Proメンバーは常に新機能がリリースされたら真っ先にアクセスできます。',
      },
      cancelAnytime: {
        title: 'リスクゼロ、全てのメリット',
        description: '完全な自由！長期契約や隠れた費用はありません。いつでもワンクリックでキャンセルできます。',
      },
      prioritySupport: {
        title: 'VIPサポートアクセス',
        description: '待ち時間はありません！あなたの質問や懸念事項は専属サポートチームによる優先的な対応を受けます。',
      },
    },
    features: {
      unlimitedDecks: '無制限デッキ作成',
      noAds: '広告なしプロキシ体験',
      prioritySupport: 'VIPサポートアクセス',
      darkMode: 'スタイリッシュなダークモード',
      advancedSearch: 'Pro検索フィルター・ツール',
      futureFeatures: '独占の新機能が順次登場',
      cancelAnytime: '簡単キャンセルオプション',
    },
    promotion: {
      title: '無制限デッキ作成を解放',
      description: '限界を破りましょう！今すぐProにアップグレードして、想像力のマッチする多くのデッキを作成しましょう。',
      customizeTitle: 'AIマジックでカードを変換',
      customizeDescription: 'Proにアップグレードして、最先端AI技術を使用して毎日最大5枚のカスタムカードバリエーションを作成しましょう！',
      banner: 'Proを7日間無料お試し！広告なし、ダークモード、無制限デッキなど。',
      tryNow: '今すぐ試す',
    },
    account: {
      title: 'あなたのProメンバーシップ',
      description: 'プレミアム特典を管理',
      subscribeToPro: '今すぐProにアップグレード',
    },
  },
  auth: {
    signIn: {
      title: 'アカウントにサインイン',
      withGoogle: 'Googleで続ける',
      withEmail: 'または次で続ける',
      sendMagicLink: 'マジックリンクを送信',
      noAccount: 'アカウントをお持ちでない方',
      checkEmail: 'サインインリンクをメールで確認してください',
      errors: {
        failed: 'サインインに失敗しました',
        failedGoogle: 'Googleでのサインインに失敗しました',
        failedEmail: 'メールでのサインインに失敗しました',
        noEmail: 'メールが見つかりません',
      },
      terms: 'サインインすることで、以下に同意したことを確認します：',
    },
    register: {
      title: 'アカウントを作成',
      haveAccount: 'すでにアカウントをお持ちですか？',
      terms: 'アカウントを作成することで、以下に同意したことを確認します：',
    },
    common: {
      termsOfService: '利用規約',
      privacyPolicy: 'プライバシーポリシー',
      and: 'および',
    },
  },
  home: {
    hero: {
      title: 'プロキシ',
      rotatingWords: ['カード', 'トークン', 'エンブレム', 'プレインズウォーカー', '統率者', '土地', 'クリーチャー', 'アーティファクト', 'エンチャント', 'インスタント'],
      description: 'TCG Stackedは、カジュアルデッキで使用するトレーディングカードゲームのプロキシカードを無料で作成できるサービスです！',
      search: {
        cards: {
          tab: 'カード',
          placeholder: 'トレーディングカードを検索...',
          error: 'ランダムカードの読み込みに失敗しました',
        },
        sets: {
          tab: 'セット',
          placeholder: 'トレーディングカードセットを検索...',
        },
        tokens: {
          tab: 'トークン',
          placeholder: 'トレーディングカードトークンを検索...',
        },
        button: '検索',
        hint: {
          cards: 'Enterキーを押すか検索をクリックしてカードを探す',
          sets: 'Enterキーを押すか検索をクリックしてセットを探す',
          tokens: 'Enterキーを押すか検索をクリックしてトークンを探す',
        },
        aria: {
          searchIcon: '検索アイコン',
          searchInput: {
            cards: 'カードを検索',
            sets: 'セットを検索',
            tokens: 'トークンを検索',
          },
        },
      },
      images: {
        cardAlt: 'マジックカードの画像',
      },
      processedCount: '🎉 コミュニティのために{{count}}以上の無料プロキシを処理しました！ 🎉',
    },
    features: {
      section1: {
        badge: 'プロキシを印刷',
        title: 'MTGプロキシカードを印刷',
        subtitle: 'カードを印刷リストに追加し、印刷して今すぐデッキで使用できます！',
        features: [
          {
            name: '印刷リストにカードを追加',
            description: '検索ページでカードを探すか、セットを閲覧して、欲しいカードを印刷リストに追加できます。',
          },
          {
            name: 'カードを印刷',
            description: '印刷リストに追加したいカードをすべて追加したら、印刷してデッキで使用できます。',
          },
          {
            name: 'デッキで使用',
            description: 'カードを印刷したら、デッキで使用できます。カードを切り取って基本土地に貼り付けるか、基本土地を入れたスリーブの中に入れて使用します。',
          },
        ],
        images: {
          cartScreenshot: '印刷リストにカードを追加する方法を示すカート画面のスクリーンショット',
        },
      },
      section2: {
        badge: 'デッキビルダー',
        title: 'Magic: The Gatheringのデッキを作成・管理',
        subtitle: '自分のデッキを作成・管理したり、コミュニティが作成した公開デッキを閲覧したりできます。',
        features: [
          {
            name: 'MTGデッキを管理',
            description: 'すべてのユーザーは1つのMTGデッキを作成・管理できます。Proメンバーは無制限にデッキを作成できます。',
          },
          {
            name: 'カードを印刷',
            description: 'デッキに追加したいカードをすべて追加したら、一度に印刷リストに追加できます。',
          },
          {
            name: '公開デッキを閲覧',
            description: 'コミュニティが作成した完全なデッキを印刷リストに追加して、新しいデッキを簡単にテストできます。',
          },
        ],
        images: {
          deckBuilderScreenshot: 'デッキの管理方法を示すデッキビルダーインターフェース',
        },
      },
    },
  },
  footer: {
    copyright: 'TCG Stacked、全著作権所有。',
    disclaimer: 'TCG Stackedは、いかなるトレーディングカードゲーム出版社によっても製作、承認、支援、または提携されていません。',
    affiliate: 'TCGplayerのアフィリエイトパートナーとして、TCG Stackedは対象となる購入に対して手数料を得ることがあります。',
    builtBy: '製作者',
    minnerLabs: 'Minner Labs',
    privacyPolicy: 'プライバシーポリシー',
    termsOfService: '利用規約',
    support: 'サポート',
  },
  sort: {
    nameAsc: '名前（A〜Z）',
    nameDesc: '名前（Z〜A）',
    cmcAsc: 'マナ値（低い順）',
    cmcDesc: 'マナ値（高い順）',
    usdAsc: '価格（安い順）',
    usdDesc: '価格（高い順）',
    rarityAsc: 'レアリティ（コモンからミシック）',
    rarityDesc: 'レアリティ（ミシックからコモン）',
    releasedDesc: '発売日（新しい順）',
    releasedAsc: '発売日（古い順）',
  },
  pages: {
    search: {
      heading: '検索',
    },
    sets: {
      heading: 'カードセット',
      latestSets: '最新のセット',
      upcomingSets: '近日発売のセット',
      allSets: 'すべてのセット',
      noResults: '結果が見つかりません。',
    },
    set: {
      notFound: 'セットが見つかりません。',
      noCards: 'このセットにカードが見つかりません。',
      addAll: '{{count}}枚のカードを印刷リストに追加',
      addedToList: '{{count}}枚のカードを印刷リストに追加しました',
    },
    tokens: {
      heading: 'トークン',
    },
    emblems: {
      heading: 'エンブレム',
    },
    import: {
      heading: '印刷リストにカードをインポート',
      description: '印刷リストに追加したいすべてのカード名を入力してください。',
    },
    topProxies: {
      heading: '人気のプロキシ',
      description: 'TCG Stackedで最も人気のある50枚のMTGプロキシカードです。',
    },
  },
  hero: {
    game: {
      pokemon: {
        tab: 'ポケモン',
      },
      mtg: {
        tab: 'Magic: The Gathering',
      },
    },
    search: {
      cards: {
        placeholder: 'カードを検索...',
      },
      sets: {
        placeholder: 'カードセットを検索...',
      },
      button: '検索',
      hint: {
        cards: 'Enterキーを押すか検索をクリックしてカードを検索',
        sets: 'Enterキーを押すか検索をクリックしてセットを検索',
      },
      aria: {
        searchIcon: '検索アイコン',
        searchInput: {
          cards: 'カードを検索',
          sets: 'セットを検索',
        },
      },
    },
  },
  mtg: {
    hero: {
      title: 'プロキシ',
      rotatingWords: ['カード', '土地', 'クリーチャー', 'アーティファクト', 'プレインズウォーカー'],
      description: 'Magic: The Gatheringトレーディングカードゲームのカードを検索、閲覧、プロキシ作成。',
      search: {
        cards: {
          tab: 'カード',
          placeholder: 'MTGカードを検索...',
          error: 'ランダムMTGカードの取得に失敗しました',
        },
        sets: {
          tab: 'セット',
          placeholder: 'MTGカードセットを検索...',
        },
        button: '検索',
        hint: {
          cards: 'Enterキーを押すか検索をクリックしてカードを検索',
          sets: 'Enterキーを押すか検索をクリックしてセットを検索',
        },
        aria: {
          searchIcon: '検索アイコン',
          searchInput: {
            cards: 'Magicカードを検索',
            sets: 'Magicセットを検索',
          },
        },
      },
      images: {
        cardAlt: 'Magicカード画像',
      },
      processedCount: '当社のデータベースで{{count}}枚以上のMagic: The Gatheringカードを探索しましょう！',
    },
  },
  pokemon: {
    hero: {
      title: 'プロキシ',
      rotatingWords: ['ポケモン', 'トレーナー', 'エネルギー', 'EX', 'GX', 'V', 'VMAX'],
      description: 'ポケモントレーディングカードゲームのカードを検索、閲覧、プロキシ作成。',
      search: {
        cards: {
          tab: 'カード',
          placeholder: 'ポケモンカードを検索...',
          error: 'ランダムポケモンカードの取得に失敗しました',
        },
        sets: {
          tab: 'セット',
          placeholder: 'ポケモンカードセットを検索...',
        },
        button: '検索',
        hint: {
          cards: 'Enterキーを押すか検索をクリックしてカードを検索',
          sets: 'Enterキーを押すか検索をクリックしてセットを検索',
        },
        aria: {
          searchIcon: '検索アイコン',
          searchInput: {
            cards: 'ポケモンカードを検索',
            sets: 'ポケモンセットを検索',
          },
        },
      },
      images: {
        cardAlt: 'ポケモンカード画像',
      },
      processedCount: '当社のデータベースで{{count}}枚以上のポケモンカードを探索しましょう！',
    },
    sets: {
      heading: 'ポケモンカードセット',
      latestSets: '最新セット',
      upcomingSets: '今後のセット',
      allSets: 'すべてのセット',
      noResults: '結果が見つかりません。',
      sortBy: '並び替え',
      sort: {
        nameAsc: '名前 (A to Z)',
        nameDesc: '名前 (Z to A)',
        releaseDateDesc: '発売日 (新しい順)',
        releaseDateAsc: '発売日 (古い順)',
      },
      filterBy: 'シリーズでフィルター',
      allSeries: 'すべてのシリーズ',
    },
    set: {
      notFound: 'ポケモンセットが見つかりません。',
      backToSets: 'セットに戻る',
      cards: 'カード',
      released: '発売日',
      noCards: 'このセットにカードが見つかりません。',
      tryAdjusting: '検索条件を調整して探しているものを見つけてください。',
      sortBy: '並び替え',
      filterBy: 'フィルター',
      allTypes: 'すべてのタイプ',
      allRarities: 'すべてのレアリティ',
      searchPlaceholder: 'このセット内のカードを検索...',
    },
    card: {
      notFound: 'ポケモンカードが見つかりません。',
      backToSearch: '検索に戻る',
      addToPrintList: '印刷リストに追加',
      removeFromPrintList: '印刷リストから削除',
      inPrintList: '印刷リスト内',
      buyOn: 'TCGplayerで購入',
      details: '詳細',
      type: 'タイプ',
      rarity: 'レアリティ',
      set: 'セット',
      artist: 'アーティスト',
      number: 'カード番号',
      flavorText: 'フレーバーテキスト',
      attacks: '技',
      abilities: '特性',
      weakness: '弱点',
      resistance: '抵抗力',
      retreatCost: '逃げるコスト',
      legality: '使用可能フォーマット',
      otherVersions: '他のバージョン',
      youMightAlsoLike: 'おすすめ',
    },
  },
  feedback: {
    buttonLabel: 'フィードバック',
    title: 'フィードバックを共有',
    description: 'TCG Stackedの改善のためにご意見をお寄せください。あなたの考えを私たちと共有してください。',
    categoryLabel: 'カテゴリー',
    categories: {
      bug: 'バグ報告',
      feature: '機能リクエスト',
      improvement: '改善提案',
      general: '一般的なフィードバック',
      other: 'その他',
    },
    messageLabel: 'あなたのフィードバック',
    messagePlaceholder: 'あなたの考え、提案、または問題を報告してください...',
    ratingLabel: '体験を評価する（任意）',
    emailLabel: 'メールアドレス（任意）',
    emailPlaceholder: 'your@email.com',
    emailHelp: 'フォローアップを希望される場合は、メールアドレスをご提供ください。',
    submitting: '送信中...',
    submitButton: 'フィードバックを送信',
    successMessage: 'フィードバックをありがとうございます！',
    errorMessage: 'フィードバックの送信に失敗しました。もう一度お試しください。',
  },
  collection: {
    title: 'マイコレクション',
    loginRequired: 'ログインが必要です',
    loginMessage: 'コレクションを表示するにはログインしてください',
    emptyCollection: 'カードが見つかりません',
    emptyCollectionMessage: 'コレクションが空です。カード詳細ページからカードを追加するか、一括追加機能を使用してください。',
    noMatchingCards: 'フィルターに一致するカードがありません。',
    searchPlaceholder: 'カードを検索...',
    sortBy: '並び替え',
    sortName: '名前',
    sortPrice: '価格',
    sortDate: '追加日',
    sortQuantity: '数量',
    filterRarity: 'レアリティ',
    filterSet: 'セット',
    allRarities: 'すべてのレアリティ',
    allSets: 'すべてのセット',
    filters: 'フィルター',
    clearFilters: 'フィルターをクリア',
    sortAscending: '昇順に並べ替え',
    sortDescending: '降順に並べ替え',
    bulkAdd: '一括追加',
    bulkAddTitle: '印刷リストからカードを追加',
    bulkAddDescription: '印刷リストのすべてのカードをコレクションに追加します。',
    bulkAddCount: '{{count}}枚のカードがコレクションに追加されます。',
    emptyCart: '印刷リストが空です',
    bulkAddSuccess: 'カードがコレクションに追加されました',
    bulkAddError: 'カードをコレクションに追加できませんでした',
    addToCollection: 'コレクションに追加',
    addMore: 'さらに追加',
    inCollection: 'コレクション内',
    quickAdd: 'クイック追加',
    searchCards: 'カードを検索...',
    typeToSearch: '検索するには少なくとも3文字入力してください',
    noResults: '結果が見つかりません',
    noCardSelected: 'カードが選択されていません',
    addCardToCollection: 'カードをコレクションに追加',
    addCardDescription: 'コレクションに追加する数量を指定してください。',
    quantity: '数量',
    price: '価格',
    addToCart: '印刷リストに追加',
    addedToCart: 'コレクションが印刷リストに追加されました',
    stats: 'コレクション統計',
    totalValue: '合計価値',
    filteredValue: 'フィルター後の価値',
    cardCount: 'カード数',
    totalCards: '合計カード',
    uniqueCards: 'ユニークカード',
    filteredCards: 'フィルター後のカード',
    rarityBreakdown: 'レアリティ分布',
    export: 'コレクションをエクスポート',
    exporting: 'エクスポート中...',
    exportSuccess: 'コレクションのエクスポートに成功しました',
    exportError: 'コレクションのエクスポートに失敗しました',
    noCardsToExport: 'エクスポートするカードがありません',
    exportCardName: 'カード名',
    exportSet: 'セット',
    exportRarity: 'レアリティ',
    exportQuantity: '数量',
    exportPrice: '価格',
    exportTotalValue: '合計価値',
    exportDateAdded: '追加日',
    insights: 'コレクション分析',
    noInsightsAvailable: 'コレクションの分析情報がありません',
    insightsDescription: 'コレクションの詳細統計',
    rarityDistribution: 'レアリティ分布',
    topSets: '主要セット',
    priceDistribution: '価格分布',
    // Quick add feature
    quickAdd: 'クイック追加',
    searchCards: '追加するカードを検索',
    typeToSearch: '検索するには少なくとも3文字を入力してください',
    noResults: '結果が見つかりません',
    noCardSelected: 'カードが選択されていません',
    addCardToCollection: 'コレクションにカードを追加',
    addCardDescription: 'コレクションに追加する数量を指定してください',
    quantity: '数量',
    price: '価格',
    // Clear collection feature
    clearCollection: 'コレクションをクリア',
    clearCollectionConfirmTitle: 'コレクション全体をクリアしますか？',
    clearCollectionConfirmMessage: 'この操作は元に戻せません。コレクション内のすべてのカードが完全に削除されます。',
    // Edit card in collection
    editCardInCollection: 'コレクション内のカードを編集',
    editCardDescription: 'コレクション内のこのカードの詳細を更新します。',
    viewCardDetails: 'カードの詳細を表示',
    condition: '状態',
    selectCondition: '状態を選択',
    language: '言語',
    selectLanguage: '言語を選択',
    finish: '仕上げ',
    selectFinish: '仕上げを選択',
    purchasePrice: '購入価格',
    isProxy: 'これはプロキシです',
    saveChanges: '変更を保存',
    removeCard: 'カードを削除',
    cardRemoved: 'カードがコレクションから削除されました',
    errorRemovingCard: 'カードの削除中にエラーが発生しました',
    errorSavingChanges: 'カードの変更の保存中にエラーが発生しました',
    // Landing page
    landing: {
      title: 'MTGコレクションを管理',
      description: '強力なコレクション管理ツールで、すべてのMagic: The Gatheringカードを一つの場所で追跡します。',
      intro: '当社のコレクション管理システムを使用すれば、Magic: The Gatheringカードコレクション全体を簡単に追跡、整理、評価できます。今日アカウントを作成して始めましょう！',
      createAccount: 'アカウント作成',
      getStarted: '今すぐ始める',
      howItWorks: '使い方',
      step1: '無料アカウントを作成して個人コレクションにアクセス',
      step2: '手動でカードを追加するか、CSVファイルからインポート',
      step3: 'セット、色、レアリティなどでカードを整理',
      step4: 'コレクションの価値を継続的に追跡',
      step5: '必要なときにコレクションデータをエクスポート',
    },
    features: {
      track: {
        title: 'カードを追跡',
        description: 'すべてのMagic: The Gatheringカードの詳細なインベントリを一つの場所で管理',
      },
      organize: {
        title: 'セット別に整理',
        description: 'セット、レアリティ、色などでコレクションを並べ替えとフィルタリング',
      },
      value: {
        title: '価値を監視',
        description: 'コレクション全体の現在の市場価値を一目で確認',
      },
      export: {
        title: 'データをエクスポート',
        description: 'コレクションデータをエクスポートして他のアプリケーションで使用',
      },
    },
  },
  pages: {
    search: {
      heading: '検索',
    },
    sets: {
      heading: 'カードセット',
      latestSets: '最新セット',
      upcomingSets: '今後のセット',
      allSets: 'すべてのセット',
      noResults: '結果が見つかりません。',
    },
    set: {
      notFound: 'セットが見つかりません。',
      noCards: 'このセットにカードが見つかりません。',
      addAll: '{{count}}枚のカードを印刷リストに追加',
      addedToList: '{{count}}枚のカードを印刷リストに追加しました',
    },
    tokens: {
      heading: 'トークン',
    },
    emblems: {
      heading: 'エンブレム',
    },
    import: {
      heading: '印刷リストにカードをインポート',
      description: '印刷リストに追加したいすべてのカード名を入力してください。',
    },
    topProxies: {
      heading: '人気のプロキシ',
      description: 'TCG Stackedで最も人気のある50枚のMTGプロキシカードです。',
    },
  },
  hero: {
    game: {
      pokemon: {
        tab: 'ポケモン',
      },
      mtg: {
        tab: 'Magic: The Gathering',
      },
    },
    search: {
      cards: {
        placeholder: 'カードを検索...',
      },
      sets: {
        placeholder: 'カードセットを検索...',
      },
      button: '検索',
      hint: {
        cards: 'Enterキーを押すか検索をクリックしてカードを検索',
        sets: 'Enterキーを押すか検索をクリックしてセットを検索',
      },
      aria: {
        searchIcon: '検索アイコン',
        searchInput: {
          cards: 'カードを検索',
          sets: 'セットを検索',
        },
      },
    },
  },
  mtg: {
    hero: {
      title: 'プロキシ',
      rotatingWords: ['カード', '土地', 'クリーチャー', 'アーティファクト', 'プレインズウォーカー'],
      description: 'Magic: The Gatheringトレーディングカードゲームのカードを検索、閲覧、プロキシ作成。',
      search: {
        cards: {
          tab: 'カード',
          placeholder: 'MTGカードを検索...',
          error: 'ランダムMTGカードの取得に失敗しました',
        },
        sets: {
          tab: 'セット',
          placeholder: 'MTGカードセットを検索...',
        },
        button: '検索',
        hint: {
          cards: 'Enterキーを押すか検索をクリックしてカードを検索',
          sets: 'Enterキーを押すか検索をクリックしてセットを検索',
        },
        aria: {
          searchIcon: '検索アイコン',
          searchInput: {
            cards: 'Magicカードを検索',
            sets: 'Magicセットを検索',
          },
        },
      },
      images: {
        cardAlt: 'Magicカード画像',
      },
      processedCount: '当社のデータベースで{{count}}枚以上のMagic: The Gatheringカードを探索しましょう！',
    },
  },
  pokemon: {
    hero: {
      title: 'プロキシ',
      rotatingWords: ['ポケモン', 'トレーナー', 'エネルギー', '伝説', 'キラ'],
      description: 'ポケモンカードを検索、閲覧、プロキシ作成できます。',
      search: {
        cards: {
          tab: 'カード',
          placeholder: 'ポケモンカードを検索...',
          error: 'ランダムポケモンカードの取得に失敗しました',
        },
        sets: {
          tab: 'セット',
          placeholder: 'ポケモンカードセットを検索...',
        },
        button: '検索',
        hint: {
          cards: 'Enterキーを押すか検索をクリックしてカードを検索',
          sets: 'Enterキーを押すか検索をクリックしてセットを検索',
        },
        aria: {
          searchIcon: '検索アイコン',
          searchInput: {
            cards: 'ポケモンカードを検索',
            sets: 'ポケモンセットを検索',
          },
        },
      },
      images: {
        cardAlt: 'ポケモンカード画像',
      },
      processedCount: 'データベースに{{count}}枚以上のポケモンカードがあります！',
    },
    sets: {
      heading: 'ポケモンカードセット',
      latestSets: '最新セット',
      upcomingSets: '今後のセット',
      allSets: 'すべてのセット',
      noResults: '結果が見つかりません。',
      sortBy: '並び替え',
      sort: {
        nameAsc: '名前 (A to Z)',
        nameDesc: '名前 (Z to A)',
        releaseDateDesc: '発売日 (新しい順)',
        releaseDateAsc: '発売日 (古い順)',
      },
      filterBy: 'シリーズでフィルター',
      allSeries: 'すべてのシリーズ',
    },
    set: {
      notFound: 'ポケモンセットが見つかりません。',
      backToSets: 'セットに戻る',
      cards: 'カード',
      released: '発売日',
      noCards: 'このセットにカードが見つかりません。',
      tryAdjusting: '検索条件を調整して探しているものを見つけてください。',
      sortBy: '並び替え',
      filterBy: 'フィルター',
      allTypes: 'すべてのタイプ',
      allRarities: 'すべてのレアリティ',
      searchPlaceholder: 'このセット内のカードを検索...',
    },
    card: {
      notFound: 'ポケモンカードが見つかりません。',
      backToSearch: '検索に戻る',
      addToPrintList: '印刷リストに追加',
      removeFromPrintList: '印刷リストから削除',
      inPrintList: '印刷リスト内',
      buyOn: 'TCGplayerで購入',
      details: '詳細',
      type: 'タイプ',
      rarity: 'レアリティ',
      set: 'セット',
      artist: 'アーティスト',
      number: 'カード番号',
      flavorText: 'フレーバーテキスト',
      attacks: '技',
      abilities: '特性',
      weakness: '弱点',
      resistance: '抵抗力',
      retreatCost: '逃げるコスト',
      legality: '使用可能フォーマット',
      otherVersions: '他のバージョン',
      youMightAlsoLike: 'おすすめ',
    },
  },
  feedback: {
    buttonLabel: 'フィードバック',
    title: 'フィードバックを共有',
    description: 'TCG Stackedの改善のためにご意見をお寄せください。あなたの考えを私たちと共有してください。',
    categoryLabel: 'カテゴリ',
    categories: {
      bug: 'バグ報告',
      feature: '機能リクエスト',
      improvement: '改善提案',
      general: '一般的なフィードバック',
      other: 'その他',
    },
    messageLabel: 'あなたのフィードバック',
    messagePlaceholder: 'ご意見、ご提案、または問題の報告を共有してください...',
    ratingLabel: '体験を評価（任意）',
    emailLabel: 'メール（任意）',
    emailPlaceholder: 'your@email.com',
    emailHelp: 'フォローアップを希望される場合はメールアドレスをご提供ください。',
    submitting: '送信中...',
    submitButton: 'フィードバックを送信',
    successMessage: 'フィードバックをありがとうございます！',
    errorMessage: 'フィードバックの送信に失敗しました。もう一度お試しください。',
  },
  customizeCardModal: {
    title: 'AIでカードをカスタマイズ',
    description: 'このカードをどのようにカスタマイズしたいか説明してください。AIはカードのフレームと構造を維持しながら新しいバージョンを生成します。',
    buttonText: 'AIでカスタマイズ',
    placeholder: 'カードのカスタムバリエーションを説明してください...',
    generateButton: 'カスタムカードを生成',
    generatingButton: '生成中...',
    addToPrintListButton: '印刷リストに追加',
    successMessage: 'カスタムカードが印刷リストに追加されました',
    cancelledGeneration: 'カード生成がキャンセルされました',
    remainingGenerationsOne: '今月は残り{{count}}回の生成が可能です',
    remainingGenerationsOther: '今月は残り{{count}}回の生成が可能です',
    promptIdeas: 'クイックプロンプトのアイデア',
    prompts: {
      fantasy: 'このカードをファンタジースタイルに変換し、魔法の要素、輝くルーン、幻想的な照明を追加します。カードフレームはそのままに、アートワークが中世ファンタジーの世界に属しているように見せます。',
      fantasyShort: 'ファンタジースタイル',
      scifi: 'このカードを未来的なSFの美学で再構築します。サイバネティック要素、ホログラフィックディスプレイ、ネオンに照らされたディストピアの背景を追加しながら、元のカード構造を維持します。',
      scifiShort: 'SFスタイル',
      horror: 'このカードに不気味な照明、不安を誘う要素、薄気味悪い雰囲気を持つダークなホラーテーマのメイクオーバーを施します。カードフレームを維持しながら、アートワークがホラー設定に属しているように感じさせます。',
      horrorShort: 'ホラースタイル',
      anime: 'このカードを鮮やかなアニメアートスタイルで再デザインし、大胆な色使い、ダイナミックなポーズ、表現力豊かな特徴を持たせます。カード構造はそのままに、アートワークをアニメ風のイラストに変換します。',
      animeShort: 'アニメスタイル',
      realistic: 'このカードを詳細なテクスチャ、自然な照明、生命感あふれる要素を持つフォトリアリスティックな外観にします。カードフレームを維持しながら、アートワークを超リアルなイラストに変換します。',
      realisticShort: 'リアルスタイル',
      seasonal: '現在の季節の要素を取り入れて、このカードに季節感のあるメイクオーバーを施します。時期に応じて、秋の葉、冬の雪、春の花、または夏の日差しを追加します。',
      seasonalShort: '季節感',
      steampunk: 'このカードを真鍮の歯車、蒸気駆動の機械、ヴィクトリア朝のファッション要素、産業革命の雰囲気を特徴とするスチームパンクの美学で再構築します。',
      steampunkShort: 'スチームパンク',
      chibi: 'このカードを愛らしいちびスタイルに変換し、かわいい小さなキャラクターに大きな頭と簡略化された特徴を持たせ、魅力的で遊び心のある外観にします。',
      chibiShort: 'ちびスタイル',
      append: 'カードフレーム、テキストボックス、全体的な構造を必ず維持してください。アートワークのみを変更します。',
      appendButton: 'フレーム保持テキストを追加',
    },
    error: {
      failed: 'カスタムカードの生成に失敗しました',
    },
  },
  creditPurchaseModal: {
    title: 'AI生成クレジットを購入する',
    description: 'より多くのカードをカスタマイズするための追加のAI生成クレジットを購入します。',
    buttonText: 'クレジットを購入',
    currentCredits: '現在のクレジット',
    selectPackage: 'クレジットパッケージを選択',
    purchase: '今すぐ購入',
    noCreditsWarning: '利用可能なクレジットがありません',
    lowCreditsWarning: '残りのクレジットが少なくなっています',
    buyCredits: 'クレジットを購入',
    remainingGenerationsOne: '{{count}}クレジット',
    remainingGenerationsOther: '{{count}}クレジット',
    creditPackages: {
      small: '小',
      medium: '中',
      large: '大',
    },
    loadingCredits: 'クレジット情報を読み込み中...',
    valuePerCredit: '${value}/クレジット',
    credits: 'クレジット',
    failedCheckout: '決済セッションの作成に失敗しました',
  },
  ai: {
    pageTitle: 'AIマジックであなたのプロキシカードをカスタマイズ | TCG Stacked',
    pageDescription: 'AI生成アートワークであなたのMagic: The Gatheringカードを変身させましょう。Proメンバー限定機能です。',
    hero: {
      badge: 'Pro機能',
      title: 'AIマジックであなたのプロキシカードをカスタマイズ',
      subtitle: 'Magic: The Gatheringプロキシのカスタムアートワークを数秒で作成',
      cta: 'Pro会員を無料でお試し',
    },
    features: {
      title: '指先で使える強力なAI機能',
      subtitle: '私たちのAIカスタマイズ機能は、Magic: The Gatheringプロキシカードに対する完全な創造的コントロールを提供します',
      cardIntegrity: {
        title: 'カードの完全性を維持',
        description: '私たちのAIはアートワークのみを修正し、カードフレーム、テキスト、マナシンボル、レイアウトを完全に保持します。',
      },
      creativity: {
        title: '無限の創造性',
        description: 'ファンタジーからSF、フォトリアリスティックから抽象的まで、あなたが想像できるあらゆるテーマやスタイルでカードを変身させましょう。',
      },
      instantResults: {
        title: '即時の結果',
        description: 'デザインスキルは不要で、数秒でカスタムアートワークを生成。見たいものを単に説明するだけです。',
      },
      saveCreations: {
        title: '創作物を保存',
        description: 'あなたのAI生成カードはすべてアカウントに保存され、ダッシュボードからいつでもアクセスできます。',
      },
      printAnytime: {
        title: 'いつでも印刷',
        description: 'カスタムカードをプロキシリストにいつでも追加し、コレクションの残りと一緒に印刷できます。',
      },
    },
    credits: {
      title: 'AI生成クレジット',
      subtitle: '強力で手頃な価格の使いやすいAI生成クレジットで、Magic: The Gatheringプロキシカードをカスタマイズして変身させましょう。',
      howItWorks: 'クレジットの仕組み',
      step1: {
        number: '1',
        title: 'クレジットを購入',
        description: 'あなたの創造的ニーズと予算に合ったバンドルで',
      },
      step2: {
        number: '2',
        title: 'カスタムアートワークを生成',
        description: '1生成につき1クレジットを使用して、任意のMagic: The Gatheringプロキシカード用に',
      },
      step3: {
        number: '3',
        title: '使用状況を追跡',
        description: 'アカウントダッシュボードで確認し、いつでも追加購入可能',
      },
      proAdvantage: {
        title: 'Proメンバーの特典',
        description: 'Proメンバーは、サブスクリプションの一部として毎月5つのAI生成クレジットを受け取ります。創造的な可能性を最大限に引き出すためにProに参加しましょう！',
      },
      purchaseButton: '今すぐクレジットを購入',
      unlockProButton: 'Pro会員をアンロック',
      packages: {
        title: 'クレジットパッケージ',
        small: {
          name: '小',
          credits: '5',
          price: '2.99',
          value: '$0.60/クレジット',
        },
        medium: {
          name: '中',
          credits: '15',
          price: '7.99',
          value: '$0.53/クレジット',
          popular: '人気',
        },
        large: {
          name: '大',
          credits: '30',
          price: '13.99',
          value: '$0.47/クレジット',
        },
        createDesigns: '{{credits}}種類のユニークなカードデザインを作成',
      },
    },
  },
};

export default translations;
